module.exports = __webpack_public_path__ + "static/media/directions_car-24px.c9b170b8.svg";